/** Copyright 2026 Midas Healthcare Solutions - All Rights Reserved **/

export interface FeatureFlag {
  featureName: string;
  isEnabled: boolean;
}

export const FeatureFlagNames = {
  ConfigurableRxIntercept: 'ConfigurableRxIntercept',
  ScreenCaptureEnabled: 'ScreenCaptureEnabled',
  CalcCopyPaste: 'CalcCopyPaste',
  ShieldReports: 'ShieldReports',
  ToolbarProfilePicture: 'ToolbarProfilePicture',
  AiVideoReview: 'AiVideoReview',
  SmsMessaging: 'SmsMessaging',
  VideoMetrics: 'VideoMetrics',
  AlibiPatientsAndOrders: 'AlibiPatientsAndOrders',
} as const;

export type FeatureFlagName = (typeof FeatureFlagNames)[keyof typeof FeatureFlagNames];
